// extracted by mini-css-extract-plugin
export default {"mx_MessageComposer_collision":"mx_MessageComposer_collision__rvHL1arM8_93","visible":"visible__c7tBrHB2iLoN"};